import InventoryService from "#services/InventoryService";
import { filter } from "es-toolkit/compat";
import { useEffect, useState } from "react";

export const useInventories = () => {
  const [inventories, setInventories] = useState<any[]>([]);
  const [state, setState] = useState("loading");

  useEffect(() => {
    setState("loading");

    InventoryService.getInventories()
      .then(({ data }) => {
        // All valid inventory require active stream
        const validInventories = filter(
          data,
          (inventory) => !!inventory.active_stream_id
        );
        setInventories(validInventories);
        setState("loaded");
      })
      .catch(() => setState("error"));
  }, []);

  return [inventories, state];
};
